// extracted by mini-css-extract-plugin
export default {"NewBox":"box_NewBox__T19TF","num":"box_num__BUNDf","row":"box_row__zPL7G","title":"box_title__20c31","description":"box_description__QTWcP","icon":"box_icon__2Ncee"};